export default __webpack_public_path__ + "static/media/canchapadel2.0ef23b5c.jpg";